export default __webpack_public_path__ + "static/media/roundBrackets.67c9cb0e.svg";